import React from 'react'
import Layout from '../../components/Layout/Layout'
import AboutUsComponent from '../../components/AboutUs/AboutUs'

const AboutUsPage = () => {
  return (
    <div>
        <Layout>
            <AboutUsComponent />
        </Layout>
    </div>
  )
}

export default AboutUsPage;